// NOTE: 現在使用されていない画面
// TODO: route/controller/views/jsそれぞれ削除する
import Vue from 'vue/dist/vue.esm';
import Vuelidate from 'vuelidate';
import {
  required,
  numeric,
  minLength,
  maxLength,
  email,
  sameAs,
  helpers,
} from 'vuelidate/lib/validators';

const kana_validate = helpers.regex('kana', /^[ァ-ヶー　]*$/);

Vue.use(Vuelidate);

document.addEventListener('DOMContentLoaded', () => {
  window.app_clinic_inquiry = new Vue({
    el: '#clinic_inquiry',
    components: {
      Vuelidate,
    },
    data() {
      return {
        inquiry_from_clinic: {
          name: document.querySelector("[name='inquiry_from_clinic[name]']").value,
          kana: document.querySelector("[name='inquiry_from_clinic[kana]']").value,
          zip1: document.querySelector("[name='inquiry_from_clinic[zip1]']").value,
          zip2: document.querySelector("[name='inquiry_from_clinic[zip2]']").value,
          address: document.querySelector("[name='inquiry_from_clinic[address]']").value,
          email: document.querySelector("[name='inquiry_from_clinic[email]']").value,
          email_confirm: document.querySelector("[name='inquiry_from_clinic[email]']").value,
          body: document.querySelector("[name='inquiry_from_clinic[body]']").value,
        },
        submitStatus: null,
      };
    },
    validations: {
      inquiry_from_clinic: {
        name: {
          required,
        },
        kana: {
          required,
          kana_validate,
        },
        zip1: {
          required,
          numeric,
          minLength: minLength(3),
          maxLength: maxLength(3),
        },
        zip2: {
          required,
          numeric,
          minLength: minLength(4),
          maxLength: maxLength(4),
        },
        address: {
          required,
        },
        email: {
          required,
          email,
        },
        email_confirm: {
          sameAsEmail: sameAs('email'),
        },
        body: {
          required,
        },
      },
    },
    methods: {
      submit() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          this.submitStatus = 'ERROR';
          return false;
        } else {
          this.submitStatus = 'PENDING';
          $('#clinic_inquiry').submit();
        }
      },
    },
  });
});
